module.exports = {"360828100":"芙蓉镇","360828101":"五丰镇","360828102":"枧头镇","360828103":"窑头镇","360828104":"百嘉镇","360828105":"高陂镇","360828106":"潞田镇","360828107":"沙坪镇","360828108":"夏造镇","360828200":"罗塘乡","360828201":"弹前乡","360828202":"武术乡","360828203":"宝山乡","360828204":"涧田乡","360828205":"顺峰乡","360828206":"韶口乡","360828401":"万安县工业园","360828501":"蔴源垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360828.json
// module id = 1427
// module chunks = 0